import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import "./MyMarker.css";
import projectInfoBackground from "../../assets/images/exploreBkg.png";

const MyMarker = ({ location, disableHover }) => {
  const handleClick = () => {
    console.log(`You clicked on ${location.overview}`);
  };
  const [openPopup, setOpenPopup] = useState(false);
  useEffect(() => {
    if (location.openPopup) {
      setOpenPopup(true);
    } else {
      setOpenPopup(false);
    }
  }, [location]);

  return (
    <div
      className={`circle ${disableHover ? "disable-hover" : ""}`}
      onClick={handleClick}
    >
      <div className="inner-circle" />
      <div className={`project-info-popup ${openPopup ? "show" : ""}`}>
        <div className="project-view-link">
          <Link
            to={`/project/${location.id}`}
            state={{ id: location.id }}
            style={{
              color: "rgba(0, 0, 0, 0.6)",
              fontSize: "12px",
              lineHeight: "16px",
              textDecoration: "none",
            }}
          >
            View
          </Link>
        </div>
        <div className="project-info-popup-image">
          <img src={projectInfoBackground} width="100px" height="56px" alt="" />
        </div>
        <div className="project-info-popup-panel">
          <div className="project-name">{location.name || ""}</div>
          <div className="project-overview">{location.overview || ""}</div>
        </div>
      </div>
    </div>
  );
};

export default MyMarker;
